import { useState } from "react";
import { Popover, PopoverBody, PopoverHeader } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { PopoverOnLeft, PopoveroffsetDash50 } from "../../../../Constants/Constants";

const OffsetLeft = () => {
  const [popover, setPopover] = useState(false);
  const toggle = () => setPopover(!popover);
  return (
    <>
      <Btn color="dark" className="example-popover" id="offset" onClick={toggle}>
        {PopoveroffsetDash50}
      </Btn>
      <Popover placement="left" isOpen={popover} target="offset" toggle={toggle} offset={[-50, 0]}>
        <PopoverHeader>{PopoverOnLeft}</PopoverHeader>
        <PopoverBody>{"Popovers are opt-in for effectiveness causes, in this way you have to initialize them yourself."}</PopoverBody>
      </Popover>
    </>
  );
};
export default OffsetLeft;
